import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";
import AllLogs from "./AllLogs";

const ActivityLogs = () => {
  document.title = "Activity Logs | CIMS";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Activity Logs"
            pageTitles={[
              { title: "Dashboard", link: "/dashboard" },
              { title: "User Activity", link: "#" },
            ]}
          />

          <AllLogs />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ActivityLogs;
